import { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useDebounce from "../utils/useDebounce";
import useFetchCompanies from "../utils/useFetchCompanies";
import { Company, companyOptionsType } from "../state/entities";

interface TagsInputFieldProps {
  placeholder?: string;
  value?: Company[];
  onChange?: (tags: string[]) => void;
}

export default function TagsInputField({ placeholder = "Company Name", onChange, value = [] }: TagsInputFieldProps) {
  const { companyOptions, fetchCompanies } = useFetchCompanies();
  const [fetching, setFetching] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const debounceValue = useDebounce(searchTerm, 500);

  useEffect(() => {
    async function fetchData() {
      if (!debounceValue) return;
      setFetching(true);
      await fetchCompanies(debounceValue);
      setFetching(false);
    }

    fetchData();
  }, [debounceValue]);

  function handleSearch(search: string) {
    setSearchTerm(search);
  }

  const handleTagChange = (newTags: string[]) => {
    onChange?.(newTags);
  };

  const selectedCompanyNames = value.map((company: Company) => company.companyNameAndTicker);

  // Filter out any options that match a selected company name.
  const filteredOptions = companyOptions.map(category => ({
    ...category,
    options: category.options.filter(option => {
      const companyData = JSON.parse(option.value);
      return !selectedCompanyNames.includes(companyData.symbol);
    })
  })).filter(category => category.options.length > 0);

  return (
    <Select
      showSearch
      searchValue={searchTerm}
      style={{ width: "100%", textAlign: "left" }}
      placeholder={placeholder}
      onSearch={handleSearch}
      onChange={handleTagChange}
      filterOption={false}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      options={filteredOptions}
    />
  );
}
